import type { Rect } from "../game/input";

export interface AuthGateLayoutParams {
  canvasWidth: number;
  canvasHeight: number;
  mobile: boolean;
  logoHeight?: number;
}

export interface AuthGateLayout {
  logoRect: Rect;
  emailFormRect: Rect;
  dividerY: number;
  loginGoogle: Rect;
  loginDiscord: Rect;
  authErrorY: number;
}

function btnW(mobile: boolean): number { return mobile ? 280 : 196; }
function btnH(mobile: boolean): number { return mobile ? 44 : 36; }
function btnGap(mobile: boolean): number { return mobile ? 12 : 8; }

function formH(mobile: boolean): number {
  const rowH = mobile ? 44 : 36;
  const gaps = mobile ? 8 : 6;
  const toggleH = mobile ? 18 : 14;
  return rowH * 3 + gaps + toggleH;
}

export function resolveAuthGateLayout({
  canvasWidth,
  canvasHeight,
  mobile,
  logoHeight = 60,
}: AuthGateLayoutParams): AuthGateLayout {
  const cw = Math.max(1, canvasWidth);
  const ch = Math.max(1, canvasHeight);
  const cx = cw / 2;

  const bw = btnW(mobile);
  const bh = btnH(mobile);
  const bg = btnGap(mobile);
  const fh = formH(mobile);
  const logoW = mobile ? 110 : 160;
  const logoH = Math.max(1, Math.round(logoHeight));
  const bx = Math.round(cx - bw / 2);

  // Total stack: logo + gap + form + gap + Google + gap + Discord
  const gap = 64;
  const total = logoH + gap + fh + gap + bh + bg + bh;

  let y = Math.round((ch - total) / 2);
  y = Math.max(20, y);

  const logoY = y;
  const formY = logoY + logoH + gap;
  const dividerY = formY + fh - 16;
  const googleY = dividerY + 10;
  const discordY = googleY + bh + bg;

  return {
    logoRect: { x: Math.round(cx - logoW / 2), y: logoY, w: logoW, h: logoH },
    emailFormRect: { x: bx, y: formY, w: bw, h: fh },
    dividerY,
    loginGoogle: { x: bx, y: googleY, w: bw, h: bh },
    loginDiscord: { x: bx, y: discordY, w: bw, h: bh },
    authErrorY: discordY + bh + 18,
  };
}
